// tslint:disable-next-line:no-var-requires
const repeat = require('handlebars-helper-repeat');

module.exports = (repeat);
